import React from 'react';

export interface CheckboxSwitchProps {
    title: string;
    checked: boolean;
    onChange: React.ChangeEventHandler<HTMLInputElement>;
}

const CheckboxSwitch = (props: CheckboxSwitchProps) => {
    const { title, checked, onChange } = props;

    return (
        <div className="checkbox-switch">
            <label className="switch">
                <input
                    id="checkbox-switch-input"
                    className={`checkbox-switch-input ${checked ? 'checked' : ''}`}
                    type="checkbox"
                    checked={checked}
                    onChange={onChange}
                    data-testId="checkbox-switch-input"
                />
            </label>
            <label id="checkbox-label" className="checkbox-label" data-testId="checkbox-label">
                {title}
            </label>
        </div>
    );
};

export default CheckboxSwitch;
